module.exports = __webpack_public_path__ + "static/blueShape-ca8a0e14c43a9885eada63fd128870ed.jpg";